module.exports = __webpack_public_path__ + "static/media/logo_tbc.85c7ea01.svg";